import { handledGetFetch } from '../../submodules/shared/utils/api-base';

import { PATHS } from './paths';
import { buildUrl } from './url';

export const getStudentProducts = (studentId) => handledGetFetch(buildUrl(PATHS.account(studentId)));

export const getUserLabs = (userId) => handledGetFetch(buildUrl(PATHS.users(userId)));
